import CircleLoader from './circle-loader';

export default CircleLoader;
